import { UIControl, UIView, UIViewController, UICollectionView, UICollectionViewDatasource, UICollectionViewDelegate, UILabel } from "uikit";
import { MUIComboBox } from "muikit";
import { IndexPath, NSLocalizeString } from "foundation";
import { DLDB } from "dldb";
import { HeaderCell } from "./HeaderCell";
import { StepView, StepViewProtocol } from "./StepView";

export interface BookingRestaurantProtocolDelegate
{
  onTimeDidChange ( vc: BookingRestaurantViewController, timeID:string ) : void ;
}

export interface ZoneInfoTimeRange
{ 
  hour: string
  id: string
}

export interface ZoneInfoTimeGroup
{ 
  title: string
  startHour: string
  times: ZoneInfoTimeRange[]
}

export interface ZoneInfo
{
  id: string
  name: string
  groups: ZoneInfoTimeGroup[]
  price: number
  currency: string
//  payment_by: 0 // price?.paymentBy.rawValue ?? 0
}

export class BookingRestaurantViewController extends UIViewController implements UICollectionViewDatasource, UICollectionViewDelegate, StepViewProtocol
{
    delegate         : BookingRestaurantProtocolDelegate = null ;
    date             : string             = null ;
    zone_id          : string             = null ;
    time_id          : string             = null ;
    numPeople        : number             = -1 ;
    
    stepView: StepView;

    private zoneView         : UIView ;
    private zoneComboBox     : MUIComboBox ;
    private zoneSpinner      : UIView ;
    
    private timeView           : UIView;
    private timeCollectionView : UICollectionView ;
    private timeSpinner        : UIView ;

    // private zoneSpinner      : MUIActivityIndicatorView = null ;
    // private timeSpinner      : MUIActivityIndicatorView = null ;

    private errorZoneView    : UIView ;
    private errorTimeView    : UIView ;

    private noSelectedDateLabel : UILabel;
    private closedDayLabel : UILabel;
    
    errors           : string[] = [] ;

    private _timetable : ZoneInfo[] = [] ;

    viewDidLoad ( )
    {
      this.zoneView.hidden = true;
      this.zoneComboBox.hidden = false ;
      this.zoneSpinner.hidden = true ;
      this.zoneComboBox.addTarget( this, this.onZoneChange, UIControl.Event.valueChanged ) ;

      this.timeView.hidden = true;
      this.timeSpinner.hidden = true ;        
      this.timeCollectionView.dataSource = this;
      this.timeCollectionView.delegate = this;      

      if (DLDB.shared.customCloseDayMessages) {
        let txt = "";
        for (const msg of DLDB.shared.customCloseDayMessages) {
          txt += msg + "<br>";
        }        
        this.closedDayLabel.text = txt;
      }
      this.closedDayLabel.hidden = true;

      this.setErrors( [] ) ;
      
      if ( this.date ) this.reloadZones( ) ;      
    }


    set timetable ( new_zones: ZoneInfo[] )
    {
      const name = ( zone: ZoneInfo ) => zone.name + (zone.price?  " (" +  zone.price + ")" : "") ;

      this._timetable = new_zones ;

      if ( !this._timetable.find( z => z.id === this.zone_id ) ) this.zone_id = "" ;

      for ( const zone of this._timetable )
            if ( !zone.name ) zone.name = NSLocalizeString( "ANY", "ANY" ) ;

      if ( this.zoneComboBox )
      {
           this.zoneComboBox.removeAllItems( ) ;
           this.zoneComboBox.addItem( "--", "" ) ;

           for ( const zone of new_zones ) {
                 this.zoneComboBox.addItem( name( zone ), zone.id ) ;
           }

           if ( this.zone_id !== "" )
                this.zoneComboBox.selectItem( this.zone_id ) ;

          //  this.zoneComboBox.setEnabled( true ) ;
      }

      // CASE: Autoselect if there is only _one_ option available
      if ( new_zones.length === 1 && this.zone_id === "" )
      {           
          this.zoneComboBox.selectItem( new_zones[ 0 ].id ) ;           
          this.onZoneChange( ) ;
      }
      else
        this.timeCollectionView.reloadData( ) ;

      // Disable zone selection in case there's only one zone
      this.zoneView.hidden = ( new_zones.length <= 1 );
    }

    setNumPeople = ( people : number ) =>
    {
      this.numPeople = people;
      this.reloadZones( ) ;
    }

    setDate = ( date: string ) =>
    {
      this.noSelectedDateLabel.hidden = true;
      this.timeView.hidden = false;
      this.date = date ;
      DLDB.shared.cart().date = date;
      this.reloadZones( ) ;
    }

    onZoneChange( )
    {
      let value = this.zoneComboBox.selectedItem
      if ( value !== "" ) this.clearError( "zone" ) ;

      this.zone_id = value ;

      const zone = this._timetable.filter( z => z.id === value )[ 0 ] ;

      this.timeCollectionView.reloadData( ) ;
    }

    // // onTimeChange = ( _cb: any, value: string ) =>
    // // {
    // //   if ( value !== "" )
    // //        this.clearError( "time" ) ;

    // //   this.time_id = value ;
    // // }


    reloadZones = ( ) =>
    {
      if ( this.date == null || this.numPeople == -1 ) 
      {
          this.timetable = [] ;
          return ;
      }

      this.timeSpinner.hidden = false ;
      this.zoneSpinner.hidden = false ;
      this.zoneComboBox.enabled = false ;
      // TODO: Disable time...      
      this.time_id = "" ;
      
      this.closedDayLabel.hidden = true;
      this.timetable = [] ;
      this.timeCollectionView.reloadData();
      DLDB.shared.bookingAvailableRangeForToday( this.date, this.numPeople, ( code:number, res:any ) =>
      {
        if ( code === 200 ){
            this.timetable = res.data || [] ;
        }

        this.timeSpinner.hidden = true ;
        this.zoneSpinner.hidden = true ;        
        if (this.selected_zone == null || (this.selected_zone && this.selected_zone.groups.length === 0 )) {
          this.timeView.hidden = true;
          this.closedDayLabel.hidden = false;
        }
      } );
    }

    notify ( )
    {
      this.delegate?.onTimeDidChange( this, this.time_id ) ;
    }

    public clear() {
      this.date = "";
      this.zone_id = "";
      this.time_id = "";
      this.numPeople = 2;

      this.noSelectedDateLabel.hidden = false;
      this.closedDayLabel.hidden = true;

      this.zoneView.hidden = true;
      this.zoneSpinner.hidden = true ;
      this.timeView.hidden = true;
      this.timeSpinner.hidden = true ;   
      
      this.setErrors( [] ) ;     
    }


    check ( dryRun: boolean = true )
    {
      const checkIsValid = ( field: string, valid: boolean ) =>
            {
              if ( !valid )
                   this.errors.push( field ) ;

              return valid ;
            } ;

      // const min_date = new Date( (new Date( )).toISOString( ).split( 'T' )[ 0 ] ) ;
      const ret = [ checkIsValid( "time"  , this.time_id !== null && this.time_id !== "" ) // TODO: what is the time format?
                  , checkIsValid( "zone"  , this._timetable.length <= 1 || this.zone_id !== "" )
                  ].reduce( (acc,valid) => acc && valid, true ) ;

      if ( !dryRun )this.setErrors( this.errors ) ;

      return ret ;
    }


    setErrors ( errors: string[] )
    {
      const errorSpec = this.errorSpec( ) ;

      for ( const err in errorSpec )
            this.clearError( err ) ;

      for ( const err of errors )
            if ( err in errorSpec )
                 errorSpec[ err ].hidden = false ;
    }


    clearError ( error: string )
    {
      const errorSpec = this.errorSpec( ) ;

      this.errors = this.errors.filter( e => e !== error ) ;

      if ( errorSpec.hasOwnProperty( error ) )
           errorSpec[ error ].hidden = true ;
    }


    private errorSpec ( )
    {
      return { "time"   : this.errorTimeView
             , "zone"   : this.errorZoneView
             }
    }

    public asJSON ( )
    {
      return { pax   : this.numPeople
             , zoneID: this.zone_id !== ""? this.zone_id : undefined
             , timeID: this.time_id
             }
    }

    get hour ( )
    {
      const zone = this.selected_zone ;

      if ( !zone ) return "" ;

      for ( const z of zone.groups )
         {
            const time = z.times.find( t => t.id === this.time_id ) ;

            if ( !!time ) 
                 return time.hour ;
         }

      return "" ;
    }


    // TIME COLLECTION VIEW
    numberOfSections ( cv: UICollectionView )
    {
      const zone = this.selected_zone ;

      return zone ? zone!.groups.length : 0 ;
    }

    get selected_zone ( )
    {
       return this._timetable.find( z => z.id === this.zone_id ) ;
    }

    numberOfItemsInSection ( _collectionView: UICollectionView, group: number )
    {
        return this.selected_zone.groups[ group ].times.length ;
    }    

    viewForSupplementaryViewAtIndex ( collectionView: UICollectionView, headerName: "header" | "footer", group: number )
    {
       if ( headerName === "footer" )
            return null ;

       const data   = this.selected_zone.groups[ group ]
           , header = collectionView.dequeueReusableSupplementaryViewWithReuseIdentifier( "sectionHeader" ) as HeaderCell ;

       header.title = data.title ;

       return header ;
    }

    cellForItemAtIndexPath ( collectionView: UICollectionView, indexPath: IndexPath )
    {
        const data = this.selected_zone.groups[ indexPath.section ]
            , time = data.times[ indexPath.row ]
            , cell = collectionView.dequeueReusableCellWithReuseIdentifierFor( "timeCell", indexPath ) as HeaderCell ;
  
        cell.title = time.hour ;

        return cell;
    }

     didSelectCellAtIndexPath ( cv: UICollectionView, indexPath: IndexPath )
     {
        this.time_id = this.selected_zone.groups[ indexPath.section ].times[ indexPath.row ].id ;
      
        if ( this.time_id !== "" )
             this.clearError( "time" ) ;


        DLDB.shared.cart().time = this.time_id;
        this.notify();
     }
}